import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthInitService } from './compartidos/services/auth-init.service';
import { authCheckedSignal } from './state/auth.state';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected title = 'Mueba';

  // Exponemos el estado de autenticación reactiva para el template
  authCheckedSignal = authCheckedSignal;

  private titleService = inject(Title);
  private blinkInterval: any;

  /**
   * Forzamos la inyección de AuthInitService para que su constructor
   * se ejecute al arrancar la app.
   * 
   * Esto es esencial para activar onAuthStateChanged y cargar el perfil
   * del usuario desde Firestore. Angular standalone no instanciará el
   * servicio si no se usa en ningún lado explícitamente.
   */
  private _ = inject(AuthInitService);

  constructor() {
    this.titleService.setTitle("Mueba - Monitoreo de uso eficiente y balance"); // Establece el título inicial
    this.title = this.titleService.getTitle(); // Obtiene el título original
    this.handleVisibilityChange();
  }

  handleVisibilityChange() {
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        this.startBlinking();
      } else {
        this.stopBlinking();
      }
    });
  }

  startBlinking() {
    let isOriginalTitle = true;
    this.blinkInterval = setInterval(() => {
      this.titleService.setTitle(isOriginalTitle ? "¡Hey!, regresa a monitorear..." : this.title);
      isOriginalTitle = !isOriginalTitle;
    }, 10000);
  }

  stopBlinking() {
    clearInterval(this.blinkInterval);
    this.titleService.setTitle(this.title);
  }
}
